import React from "react";

const ComponentLoader = ({ active = true, label = "Loading", inline = false }) => {
  if (!active) {
    return null;
  }

  return (
    <div
      className={`new-hrm-component-loader${inline ? " new-hrm-component-loader--inline" : ""}`}
      role="status"
      aria-live="polite"
    >
      <span className="new-hrm-component-loader__mark" aria-hidden="true">
        <img src="/assets/antrazal-brand-mark.svg" alt="" />
      </span>
      <strong>{label}</strong>
    </div>
  );
};

export default ComponentLoader;
